module.exports = __webpack_public_path__ + "img/中雪.83fa1522.png";